import React from 'react';
import { useBeats } from '../../../hooks/useBeats';
import { StageLayout } from '../StageLayout';
import { deviations, forceClip } from '../../../data/tracking';
const BEATS = [400, 900, 1400, 2200];

/** The clinical insight: small deviations, real consequences for force. */
export function Page4Insight() {
  const beat = useBeats(BEATS);
  return <StageLayout copy={<>
          <h2 className="max-w-[400px] font-headline text-[24px] font-extrabold leading-[1.1] text-white opacity-0-init animate-fade-in-up md:text-[40px]" data-id="element-204" data-mp="2dhn546fzmg1">
            Small deviations can alter force vectors.
          </h2>

          <div className={`mt-6 flex items-center gap-4 transition-[opacity,transform] duration-300 ease-out ${beat >= 4 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-205" data-mp="3omiuv9kxzre9">
            <img src={forceClip.image} alt={forceClip.alt} className="h-16 w-20 flex-shrink-0 rounded-lg object-cover md:h-24 md:w-32" data-id="element-206" data-mp="1ms1h39ukdzl7" />
            <p className="max-w-[240px] font-headline text-[15px] font-bold leading-snug text-solventum-primary md:text-xl" data-id="element-207" data-mp="2kaso6cx41yph">
              The force delivered can differ from the force planned.
            </p>
          </div>
        </>} visual={<ul className="w-full max-w-[360px] space-y-2.5" data-id="element-208" data-mp="2p4n4d6dibvjt">
          {deviations.map((deviation, index) => <li key={deviation.name} className={`flex items-center gap-3 rounded-xl border border-white/12 p-2 transition-[opacity,transform] duration-200 ease-out ${beat > index ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-209" data-mp="21esrwpx3o903" data-mpi={index}>
              <img src={deviation.image} alt={deviation.alt} className="h-12 w-14 flex-shrink-0 rounded-lg object-cover md:h-16 md:w-20" data-id="element-210" data-mp="3ltup4c6ay0mo" />
              <div className="min-w-0" data-id="element-211" data-mp="2ehc6162taanl">
                <p className="font-body text-[10px] uppercase tracking-[0.2em] text-solventum-primary md:text-[11px]" data-id="element-212" data-mp="2egalmazwobt7">
                  {deviation.name}
                </p>
                <p className="mt-1 font-body text-[12px] leading-snug text-white/60 md:text-[13px]" data-id="element-213" data-mp="2of03i3rsxw9g">
                  {deviation.body}
                </p>
              </div>
            </li>)}
        </ul>} data-id="element-203" data-mp="gbpfeysj9zkv" />;
}